import { DefaultState } from 'store/types';

export const ALL_PREFERRED_ROOMMATES_REQUEST = 'ALL_PREFERRED_ROOMMATES_REQUEST';
export const ALL_PREFERRED_ROOMMATES_SUCCESS = 'ALL_PREFERRED_ROOMMATES_SUCCESS';
export const ALL_PREFERRED_ROOMMATES_FAILURE = 'ALL_PREFERRED_ROOMMATES_FAILURE';

export interface AllPreferredRoommatesRow {
  id: string;
};

export type AllPreferredRoommatesData = AllPreferredRoommatesRow[];

export type AllPreferredRoommatesState = DefaultState & {
  contents?: AllPreferredRoommatesData;
};

interface ReadAllPreferredRoommatesRequest {
  type: typeof ALL_PREFERRED_ROOMMATES_REQUEST;
};

interface ReadAllPreferredRoommatesSuccess {
  type: typeof ALL_PREFERRED_ROOMMATES_SUCCESS,
  contents: AllPreferredRoommatesData;
}

interface ReadAllPreferredRoommatesFailure {
  type: typeof ALL_PREFERRED_ROOMMATES_FAILURE;
}

export type AllPreferredRoommatesActionTypes = ReadAllPreferredRoommatesRequest | ReadAllPreferredRoommatesSuccess | ReadAllPreferredRoommatesFailure;